import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';


export class MultiSelectItem {
  label: string;
  name: string;
  value: any;
  isSelected: boolean = true;
}

@Component({
  selector: 'multi-selector',
  templateUrl: 'multi-selector.html'
})
export class MultiSelectorComponent {
  @Input() title: string;
  @Input() items: MultiSelectItem[];
  @Input() isSelectAll: boolean = true;
  @Output() onSelect: EventEmitter<MultiSelectItem[]> = new EventEmitter ();
  
  suggestions: MultiSelectItem[];
  showDropDown: boolean = false;
  focusedIndex: number = -1;
  

  @ViewChild('inputTxt')
  inputTxt: ElementRef;
  
  @ViewChild("suggestListRef")
  suggestListElRef: ElementRef;
  

  get selectedLabel(): string {
    if (this.isSelectAll) return '전체선택';
    let label: string = '';

    if (this.items && this.items.length > 0) {
      this.items.forEach((value, index, list) => {
        if (value.isSelected === false) return;
        if (label.length > 0) label += ', ';
        label += value.name;
      });
    } else {

    }
    return label;
  }


  get selectedValues(): MultiSelectItem[] {
    let selItems:MultiSelectItem[] = this.items.filter(value => value.isSelected);
    return selItems;
  }


  constructor() {

  }

  clickOutside() {
    this.showDropDown =  false;
  }

  toggleDropDown() {
    this.showDropDown = !this.showDropDown;
    if (this.showDropDown) {
      this.suggestions = this.items;
      if (this.inputTxt) this.inputTxt.nativeElement.focus();
    }
  }

  
  private onClickSelectAll(event) {
    this.selectAll(event.target.checked);
  }
  

  private toggleSelectAll(event) {
    this.isSelectAll = !this.isSelectAll;
    this.selectAll(this.isSelectAll);
    event.preventDefault();
  }
  
  selectAll(value) {
    this.items.forEach(item => {
      item.isSelected = value;
    })
    this.onSelect.emit(this.items);
  }
  

  private onMouseOver(index: number) {
		this.focusedIndex = index;
  }

  private toggleItem(event, item: MultiSelectItem) {
    this.setItemSelect(item, !item.isSelected);
    event.preventDefault();
	}
  
  setItemSelect(item: MultiSelectItem, value: boolean) {
    item.isSelected = value;
    if (this.isSelectAll && !value) this.isSelectAll = false;
  }


  onKeyUp(e) {
    if (e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 27 || e.keyCode === 38 || e.keyCode === 40) return;
    
    let value: String = e.target.value;
    const inputValue = value.toUpperCase().replace(/\s/g, '');
    const inputLength = inputValue.length;
    
    if (!inputValue || inputLength <= 0) {
      this.suggestions = this.items;
      return;
    }
    
    let letterCheck: RegExp = /[ㄱ-ㅎ|ㅏ-ㅣ]/;
    if (letterCheck.test(inputValue)) return;
    
    let filteredList: MultiSelectItem[] = [];
    let codeList = [];
		
		if (inputLength > 0) {
			filteredList = this.items.filter(
				(item: MultiSelectItem) => {
					if (item.label && item.label.toUpperCase().replace(/\s/g, '').indexOf(inputValue) >= 0) return true;
					if (item.name && item.name.toUpperCase().replace(/\s/g, '').indexOf(inputValue) >= 0) return true;
					return false;
				}
			);
		}
		
		filteredList.sort((a, b) => {
			if (a.label.length > b.label.length) return 1;
			else if (a.label.length == b.label.length) return 0;
			else return -1;
		});
		
		filteredList.sort((a, b) => {
			let aLabel:String = a.label.toUpperCase().trim().replace(/\s/g, '');
			let bLabel:String = b.label.toUpperCase().trim().replace(/\s/g, '');
			let aIdx = aLabel.indexOf(inputValue);
			let bIdx = bLabel.indexOf(inputValue);

			if (aIdx > bIdx) return 1;
			else if (aIdx == bIdx) return 0;
			else return -1;
		});
    
    this.suggestions = filteredList;
    this.focusedIndex = 0;
  }
  

}


// WEBPACK FOOTER //
// ./src/app/components/selector/multi-selector.ts